var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMng = function SvgMng(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h512v341.326H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M330.207 85.331H512v341.337H330.207zM0 85.331h181.793v341.337H0z",
    fill: "#A2001D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.163 267.125h14.84v59.359h-14.84zm-59.37 0h14.84v59.359h-14.84z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.902,
    cy: 289.386,
    r: 14.84
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.902,
    cy: 237.44,
    r: 7.421
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.054 311.647h29.682v14.84H76.054zm0-59.359h29.682v14.84H76.054zm14.843-66.786l5.255 16.173h17.006l-13.757 9.996 5.252 16.173-13.756-9.996-13.756 9.996 5.251-16.173-13.756-9.996h17.005z"
  }))));
};
export { SvgMng as ReactComponent };